import { HTTP } from '@util/http-p'

class LoginModel extends HTTP {
    checkLogin(data) {
        return this.request({
            url: 'apihome/index/login',
            data: data
        })
    }

    RemoteLogin(data) {
        return this.request({
            url: 'apihome/index/checkLogin',
            data: data
        })
    }
}

export { LoginModel }